import React from "react";
import { Modal, Row, Col, Button } from "react-bootstrap";
import { EnvironmentHelper } from "../helpers";

interface Props {
  playlistId?: number,
  screenId?: number,
  messageId?: number,
  onClose: () => void,
  shape?: string
}

export const PreviewModal: React.FC<Props> = props => {

  const [iframeContent, setIframeContent] = React.useState<React.ReactElement>(null);

  function getIframeContent() {
    let result = <></>
    //var holder = document.getElementById('previewHolder');
    const holder = document.querySelector("#iframeHolder");
    if (holder) {
      let screenWidth = 1920.0;
      let screenHeight = 1080.0;
      if (props.shape === "9:16") {
        screenWidth = 1080.0;
        screenHeight = 1920.0;
      }
      let percent = holder.clientWidth / screenWidth;
      const hPercent = holder.clientHeight / screenHeight;
      if (hPercent < percent) percent = hPercent;


      const leftOffset = screenWidth * (1.0 - percent) / 2.0;
      const topOffset = screenHeight * (1.0 - percent) / 2.0;

      if (!EnvironmentHelper.PlayerRoot) {
        return <div style={{ padding: "20px", textAlign: "center" }}>Preview not available in development mode without REACT_APP_PLAYER_ROOT environment variable</div>;
      }

      let url = EnvironmentHelper.PlayerRoot + "/display/?preview=1&screenId=" + props.screenId;
      if (props.playlistId) url = EnvironmentHelper.PlayerRoot + "/display/?preview=1&auto=1&playlistIds=" + props.playlistId
      else if (props.messageId) url = EnvironmentHelper.PlayerRoot + "/message/?id=" + props.messageId + "&preview=1";

      const previewUrl = url;
      const style: React.CSSProperties = {
        width: screenWidth,
        marginLeft: -leftOffset,
        marginRight: -leftOffset,
        height: screenHeight,
        marginTop: -topOffset,
        marginBottom: -topOffset,
        border: 0,
        transform: "scale(" + percent.toString() + ")"
      }
      result = <iframe id="previewFrame" src={previewUrl} style={style} scrolling="no" title="Message Preview"></iframe>;
    }
    return result;
  }

  React.useEffect(() => {
    setTimeout(() => {
      setIframeContent(getIframeContent());
    }, 200);

  }, []); // eslint-disable-line

  const getTitle = () => {
    if (props.playlistId) return "Preview Playlist";
    else return "Preview Screen";
  }

  const handleRemoteClick = (key: string) => {
    const previewFrame = document.getElementById('previewFrame') as HTMLIFrameElement | null;
    const cmd = { action: "key", value: key };
    if (previewFrame && previewFrame.contentWindow && EnvironmentHelper.PlayerRoot) {
      previewFrame.contentWindow.postMessage(JSON.stringify(cmd), EnvironmentHelper.PlayerRoot);
    }
  }

  return (
    <Modal id="previewModal" show={true} dialogClassName="custom-modal" bsClass="my-modal" onHide={props.onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{getTitle()}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ display: "flex" }}>
        <Row style={{ flex: 1 }}>
          <Col id="iframeHolder" md={9} sm={12} style={{minHeight:200}}>
            {iframeContent}
          </Col>
          <Col id="remoteControl" md={3} sm={12} role="group" aria-label="Remote control">
            <h2>Remote</h2>
            <Button variant="info" onClick={() => handleRemoteClick("ArrowUp")} style={{ width: 75, marginRight: 10 }} aria-label="Navigate up">Up</Button>
            <table role="presentation" style={{ marginTop: 5, marginBottom: 5, marginLeft: "auto", marginRight: "auto" }}>
              <tbody><tr>
                <td><Button variant="info" onClick={() => handleRemoteClick("ArrowLeft")} aria-label="Navigate left">Left</Button></td>
                <td style={{ paddingLeft: 5, paddingRight: 5 }}><Button variant="info" onClick={() => handleRemoteClick("Enter")} style={{ width: 75 }} aria-label="Select">Center</Button></td>
                <td><Button variant="info" onClick={() => handleRemoteClick("ArrowRight")} aria-label="Navigate right">Right</Button></td>
              </tr></tbody>
            </table>
            <Button variant="info" onClick={() => handleRemoteClick("ArrowDown")} style={{ width: 75, marginRight: 10 }} aria-label="Navigate down">Down</Button>

            <p style={{ marginLeft: 20, marginTop: 150, color: "#999", textAlign: "left" }}>Note: Some browsers may className="d-grid" videos from auto-playing.</p>
            <p style={{ marginLeft: 20, color: "#999", textAlign: "left" }}>If you receive an error, click on the black preview window and use the right button on the remote to move to the next message and videos should play.</p>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
